
export const Beneficiaries = {
    LOADING_BENEFICIARIES_LIST: "LOADING_BENEFICIARIES_LIST",
    GET_BENEFICIARIES_LIST: "GET_BENEFICIARIES_LIST",
  };

